import React from 'react';
import { reduxForm, Form } from 'redux-form';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { HashLoader } from 'react-spinners';

import { AppFileField } from 'components/form/appFileField';
import { required } from 'components/form/formValidations';
import AppModal from 'components/modal/appModal';
import { SimpleModalId } from 'constants/modalId';
import {
  PortalsUploadListFormProps,
  PortalsUploadListFormDataProps,
  PortalsUploadListFormOnSubmitProps,
} from './PortalsUploadListForm.types';
import { allowedFileExtensions, validatePortalListFile } from './PortalsUploadListForm.utils';
import styles from './PortalsUploadListForm.module.scss';

const PortalsUploadListForm = ({ form, handleSubmit, onUpload, isLoading }: PortalsUploadListFormProps) => {
  const handleOnSubmit = (values: PortalsUploadListFormDataProps) => onUpload(values);

  return (
    <AppModal
      form={form}
      id={SimpleModalId.PortalsUploadList}
      title="Upload clip sites"
      buttonIcon={faArrowUp}
      hideActionButtons={isLoading}
    >
      <Form id={form} onSubmit={handleSubmit(handleOnSubmit)}>
        {!isLoading ? (
          <AppFileField
            name="portalsList"
            label="XLSX File"
            validate={[validatePortalListFile, required]}
            extensions={allowedFileExtensions}
          />
        ) : (
          <div className={styles.loader}>
            <HashLoader />
          </div>
        )}
      </Form>
    </AppModal>
  );
};

export const PortalsUploadListFormContainer = reduxForm<
  PortalsUploadListFormDataProps,
  PortalsUploadListFormOnSubmitProps
>({
  form: 'portalsUploadListForm',
})(PortalsUploadListForm);
